import React from "react";

import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import CardRender2 from "../App/CardRender/CardRender";
import { useRef } from 'react';

// Styled Components
const CardListCont = styled.div`
  padding: 2rem 2rem;
  max-width: 1412px;
  padding-bottom: 0.4rem;
  padding-top: 0.1rem;
  background-color: #fff;
  padding-top: 1rem;
  margin-bottom: 1rem;
  position:relative;
   


  @media (min-width: 852px) {
 width: 98%;

}
  .cardiconsleft{
  display:flex;
  justify-content:center;
  align-items:center;
  border-radius:50%;
  width:31px;
  height:31px;
  z-index:22;
  position:absolute;
  right:1px;
  top:45%;
  aspect-ratio:1;
  background-color:#fff;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  cursor:pointer;

  }
    .cardiconsright{
      display:flex;
  justify-content:center;
  align-items:center;
  border-radius:50%;
  width:31px;
  height:31px;
  z-index:22;
  position:absolute;
  left:1px;
  top:45%;
  aspect-ratio:1;
  background-color:#fff;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  cursor:pointer;

  }

  @media(max-width: 851px) {
  max-width: 100vw;
  margin-bottom: 0rem;
  padding: 1px 0.5rem;
}

  @media (max-width: 601px) {
    padding: 1px 0.5rem;
    padding-left: 0;
    max-width: 100vw;
    line-height: 1.2;
    font-size: 12.4px;
    margin-bottom: 0rem;
  }
`;

const CardListHeader = styled.div`
  font-size: 32px;
  color: #333;
  padding: 0.21rem;

  margin-bottom: -0.4rem;

  @media (max-width: 601px) {
    font-size: 24px;
    
    margin-bottom: -1.4rem;

  }
`;

const HeaderTitle = styled.div`
  color: #333;
  font-size: 21px;
  margin-right: auto;
  text-align: center;
  margin-bottom: 1.4rem;
  font-family: "Ancizar Sans", sans-serif;

  @media (max-width: 601px) {
padding: .6rem .5rem;
font-size: 16px;
}

`;

const CardListCarouselInn = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  white-space: nowrap;
  gap: 11px;
  padding: 2px;

  @media (max-width: 601px) {
    padding-left: 1rem;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;




const CardListContent = styled.div``;

export default function CardList({ loading, item, carouselRef,height }) {


  const navigate = useNavigate();
 const scrollRef = useRef(null);


 const scrollLeft = () => {
  scrollRef.current.scrollLeft -= 400;
};

const scrollRight = () => {
  scrollRef.current.scrollLeft += 400;
};



  const handleProductClick = (product_id) => {
    navigate(`/view/${product_id}`);
  };

  const renderSkeletonCard = () => {
    return (
      <div
        style={{
          width: "200px",
          height: "300px",
          background: "#eee",
          borderRadius: "8px",
        }}
      />
    );
  };

  const ScrollRight=()=>{


  }

  
const ViewAllButton = styled.div`

width: 211px;
height: 40px;
display: flex;
justify-content: center;
align-items: center;
font-size: 16px;
  color: #333;
  background-color: #f3f3f3;
  border-radius: 8px;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1rem;
  margin-bottom: 1rem;

  &:hover {
    background-color: #e0e0e0;
  }

`



  return (
    <CardListCont>
      <CardListHeader>
        <HeaderTitle>{item.title}</HeaderTitle>
      </CardListHeader>

      <CardListContent>
        <div className="cardiconsleft" onClick={scrollRight}>
          <svg
            width="9"
            height="18"
            viewBox="0 0 80 148"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 2.5L74.5 73C51 97.5 4 145.9 4 143.5"
              stroke="#333333"
              stroke-width="7"
            />
          </svg>
        </div>


        <div className="cardiconsright" onClick={scrollLeft}>
        <svg width="9" height="18" viewBox="0 0 79 148" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M75.5 145.086L5.00001 74.5861C28.5 50.0861 75.5 1.68606 75.5 4.08606" stroke="#333333" stroke-width="7"/>
</svg>

        </div>
        <CardListCarouselInn ref={scrollRef}>
          {loading
            ? Array(4)
                .fill(0)
                .map((_, index) => (
                  <React.Fragment key={index}>
                    {renderSkeletonCard()}
                  </React.Fragment>
                ))
            : item.items.map((item) => (
                <React.Fragment key={item.id}>
                  <CardRender2
                    item={item}
                    handleProductClick={handleProductClick}
                    height={height}
                  />
                </React.Fragment>
              ))}
        </CardListCarouselInn>
        {!loading && item.items.length > 0 && (
          <ViewAllButton onClick={() => navigate(`/products/${item.id}`)}>
            View All
          </ViewAllButton>
        )}
      </CardListContent>
    </CardListCont>
  );
}
